<template>
  <div class="content page--unsubscribe-confirmed">
    <div class="container">
      <header-logo :logo-url="globalLogoUrl" />
      <h1 v-word:layout.unsubscribeConfirmed.header></h1>
      <h2 v-show="this.status === 'unsubscribed' || this.showAll"
          v-word:layout.unsubscribeConfirmed.text></h2>
    </div>
  </div>
</template>

<script>
import * as mixins from '../mixins';
import config from 'config';
import backendConfig from '../utils/backendConfig';
import urlUtil from '../utils/url';

export default {
  props: ['showAll', 'editMode', 'store'],
  mixins: [mixins.wordedPage, mixins.pageWithLogo],
  data() {
    return {
      status: null,
    };
  },
  created() {
    !this.editMode &&
      this.unsubscribe()
        .then(() => {
          this.status = 'unsubscribed';
          this.$emit('loaded');
        })
        .catch(() => {
          this.flash(this.wordings['flashes.generalError'], 'error');
          this.$emit('loaded');
        });
    // Edge has some problem with finally
    // .finally(() => {
    //   this.$emit('loaded');
    // });
  },
  methods: {
    unsubscribe() {
      const userId = urlUtil.parseQueryParam('userId');
      const mailingListId = urlUtil.parseQueryParam('mailingListId');

      if (!userId || !mailingListId) {
        return Promise.reject();
      }

      return backendConfig.get().then(({backendUrl}) => {
        const url =
          backendUrl + config.backend.feeds.unsubscribeMailingLists +
          '/' +
          encodeURI(userId) +
          '/' +
          encodeURI(mailingListId) +
          '?sso=' +
          encodeURI(this.store.brokerData);

        this.$emit('loading');
        return this.$http.get(url);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/UnsubscribeConfirmed.vue